module.exports = __webpack_public_path__ + "img/Icon-underlined-low.ea97ddf6.svg";